import { AppError } from './AppError';

/**
 * Error thrown when a user is not authorized to perform an action.
 */
export class NotAuthenticatedError extends AppError {
  /**
   * Creates a new NotAuthenticated instance.
   * @param message The error message.
   */
  constructor(
    message: string = 'NotAuthenticated'
  ) {
    
    super(message, 'UNAUTHENTICATED', true);
    this.name = 'NotAuthenticated';
  }

  /**
   * Creates an NotAuthenticatedError for a user that is not logged in.
   * @returns A new NotAuthenticatedError instance.
   */
  static notLoggedIn(): NotAuthenticatedError {
    return new NotAuthenticatedError('Not logged in');
  }
}